import { render, staticRenderFns } from "./CreateProduct.yaml?vue&type=template&id=69275fe0&component"
import script from "./CreateProduct.yaml?vue&type=script&lang=ts&component"
export * from "./CreateProduct.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports